<template>
  <div class="FamilyStudentsModal">
    <btn @click.native="getData" style="border-left: solid 1px #ccc; border-right: solid 1px #ccc"><i class="fa fa-user-plus"></i>生徒の追加</btn>
    <component-modal v-show="condition.condition" transition="expand">
      <template slot="title">生徒登録</template>
      <div slot="body">
        <table class="m-table">
          <tbody>
            <tr>
              <th>名前</th>
              <td>
                <input class="half" type='text' v-model="student.f_name" placeholder="姓"><input class="half" type='text' v-model="student.l_name" placeholder="名">
              </td>
            </tr>
            <tr>
              <th class="req">かな</th>
              <td>
                <input class="half" type='text' required v-model="student.f_name_kana" placeholder="せい"><input class="half" type='text' required v-model="student.l_name_kana" placeholder="めい">
              </td>
            </tr>
            <tr>
              <th class="req">性別</th>
              <td><multiselect @select="select" v-model="watch.gender" :options="gender" label="name" :show-labels="false" placeholder="性別"></multiselect></td>
            </tr>
            <tr>
              <th>生年月日</th>
              <td><input type="text" maxlength="10" minlength="10" v-model="student.birthday" placeholder="生年月日"></td>
            </tr>
            <tr>
              <th>年齢</th>
              <td><div class="calc">{{calcAge}}</div></td>
            </tr>
            <tr>
              <th>公/国/私</th>
              <td><multiselect @select="select" v-model="watch.school_type" :options="school_type" label="name" :show-labels="false" placeholder="公/国/私"></multiselect></td>
            </tr>
            <tr>
              <th>留年・浪人{{student.grade_flag}}</th>
              <td><input type='number' v-model="student.grade_flag" placeholder="留年・浪人"></td>
            </tr>
            <tr>
              <th>学年</th>
              <td><div class="calc">{{calcGrade}}</div></td>
            </tr>
            <tr>
              <th>学校名</th>
              <td><input type='text' v-model="student.school_name" placeholder="学校名"></td>
            </tr>
            <tr>
              <th>指導詳細</th>
              <td><input type='text' v-model="student.guidance_detail" placeholder="指導詳細"></td>
            </tr>
            <tr>
              <th>次回引継時期</th>
              <td><input type="text" maxlength="10" minlength="10" v-model="student.takeover_time" placeholder="次回引継時期"></td>
            </tr>
            <tr>
              <th>優先度</th>
              <td><multiselect @select="select" v-model="watch.priority" :options="priority" label="name" :show-labels="false" placeholder="優先度"></multiselect></td>
            </tr>
            <tr>
              <th class="req">役務開始</th>
              <td><input type="text" maxlength="10" minlength="10" v-model="student.service_period_start" placeholder="役務開始"></td>
            </tr>
            <tr>
              <th class="req">役務終了</th>
              <td><input type="text" maxlength="10" minlength="10" v-model="student.service_period_end" placeholder="役務終了"></td>
            </tr>
            <tr>
              <th>備考</th>
              <td><textarea v-model="student.note" placeholder="備考"></textarea></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="footer" slot="footer">
        <btn @click.native="postStudentModal">登録</btn>
        <btn @click.native="showModal">キャンセル</btn>
      </div>
    </component-modal>
  </div>
</template>

<script>
export default {
  props: {
    family: Object
  },
  name: 'FamilyStudentsModal',
  data () {
    return {
      condition: {
        condition: false
      },

      student: {
        state: 1,
        f_name: '',
        l_name: '',
        f_name_kana: '',
        l_name_kana: '',
        gender: 0,
        birthday: '0001/01/01',
        school_type: 0,
        school_name: '',
        grade_flag: 0,
        guidance_detail: '',
        takeover_time: '',
        priority: 0,
        service_period_start: '0001/01/01',
        service_period_end: '0001/01/01',
        note: ''
      },

      watch: {
        gender: '',
        school_type: '',
        priority: ''
      },

      gender: [
        { name: '未選択', value: 0 },
        { name: '男', value: 1 },
        { name: '女', value: 2 }
      ],

      school_type: [
        { name: '未選択', valu: 0 },
        { name: '公立', value: 1 },
        { name: '国立', value: 2 },
        { name: '私立', value: 3 },
        { name: 'その他', value: 4 }
      ],

      priority: [
        { name: '未選択', value: 0 },
        { name: 'メイン', value: 1 },
        { name: 'サブ', value: 2 }
      ]
    }
  },

  computed: {
    family_id () {
      return this.$store.state.item.family.id
    },

    calcAge () {
      let x = Date.parse(this.student.birthday) // 変換(ミリ秒が返される)
      let date = new Date(x) // ミリ秒をnew Dateに渡す
      let ageDifMs = Date.now() - date // 差分(ミリ秒)
      let ageDate = new Date(ageDifMs) // ミリ秒をnew Dateに渡す
      return ageDate.getUTCFullYear() - 1970
    },

    calcGrade () {
      let self = this

      let x = Date.parse(self.student.birthday) // 変換(ミリ秒が返される)
      let birthdate = new Date(x) // ミリ秒をnew Dateに渡す

      // ****/01/01-****/04/01の期間中は学年を上げない
      let year = new Date().getFullYear()
      if (new Date() >= new Date(new Date().getFullYear(), 0, 1) && new Date() <= new Date(new Date().getFullYear(), 3, 1, 23, 59)) {
        year = year - 1
      }

      // 月だけ0から始まるので4月は3
      let ageNumber
      if (birthdate >= new Date(year - 4, 3, 2) && birthdate <= new Date(year - 3, 3, 1, 23, 59)) {
        ageNumber = 4
      } else if (birthdate >= new Date(year - 5, 3, 2) && birthdate <= new Date(year - 4, 3, 1, 23, 59)) {
        ageNumber = 5
      } else if (birthdate >= new Date(year - 6, 3, 2) && birthdate <= new Date(year - 5, 3, 1, 23, 59)) {
        ageNumber = 6
      } else if (birthdate >= new Date(year - 7, 3, 2) && birthdate <= new Date(year - 6, 3, 1, 23, 59)) {
        ageNumber = 7
      } else if (birthdate >= new Date(year - 8, 3, 2) && birthdate <= new Date(year - 7, 3, 1, 23, 59)) {
        ageNumber = 8
      } else if (birthdate >= new Date(year - 9, 3, 2) && birthdate <= new Date(year - 8, 3, 1, 23, 59)) {
        ageNumber = 9
      } else if (birthdate >= new Date(year - 10, 3, 2) && birthdate <= new Date(year - 9, 3, 1, 23, 59)) {
        ageNumber = 10
      } else if (birthdate >= new Date(year - 11, 3, 2) && birthdate <= new Date(year - 10, 3, 1, 23, 59)) {
        ageNumber = 11
      } else if (birthdate >= new Date(year - 12, 3, 2) && birthdate <= new Date(year - 11, 3, 1, 23, 59)) {
        ageNumber = 12
      } else if (birthdate >= new Date(year - 13, 3, 2) && birthdate <= new Date(year - 12, 3, 1, 23, 59)) {
        ageNumber = 13
      } else if (birthdate >= new Date(year - 14, 3, 2) && birthdate <= new Date(year - 13, 3, 1, 23, 59)) {
        ageNumber = 14
      } else if (birthdate >= new Date(year - 15, 3, 2) && birthdate <= new Date(year - 14, 3, 1, 23, 59)) {
        ageNumber = 15
      } else if (birthdate >= new Date(year - 16, 3, 2) && birthdate <= new Date(year - 15, 3, 1, 23, 59)) {
        ageNumber = 16
      } else if (birthdate >= new Date(year - 17, 3, 2) && birthdate <= new Date(year - 16, 3, 1, 23, 59)) {
        ageNumber = 17
      } else if (birthdate >= new Date(year - 18, 3, 2) && birthdate <= new Date(year - 17, 3, 1, 23, 59)) {
        ageNumber = 18
      } else {
        ageNumber = 0
      }

      let gradeNumber = ageNumber + Number(self.student.grade_flag)

      // 月だけ0から始まるので4月は3
      let grade
      if (gradeNumber === 4) {
        grade = '幼稚園年少'
      } else if (gradeNumber === 5) {
        grade = '幼稚園年中'
      } else if (gradeNumber === 6) {
        grade = '幼稚園年長'
      } else if (gradeNumber === 7) {
        grade = '小学1年生'
      } else if (gradeNumber === 8) {
        grade = '小学2年生'
      } else if (gradeNumber === 9) {
        grade = '小学3年生'
      } else if (gradeNumber === 10) {
        grade = '小学4年生'
      } else if (gradeNumber === 11) {
        grade = '小学5年生'
      } else if (gradeNumber === 12) {
        grade = '小学6年生'
      } else if (gradeNumber === 13) {
        grade = '中学1年生'
      } else if (gradeNumber === 14) {
        grade = '中学2年生'
      } else if (gradeNumber === 15) {
        grade = '中学3年生'
      } else if (gradeNumber === 16) {
        grade = '高校1年生'
      } else if (gradeNumber === 17) {
        grade = '高校2年生'
      } else if (gradeNumber === 18) {
        grade = '高校3年生'
      } else {
        grade = ''
      }
      return grade
    }
  },

  watch: {
    'watch.gender': function (now, old) {
      if (now) {
        this.student.gender = now.value
      } else {
        this.student.gender = ''
      }
    },

    'watch.school_type': function (now, old) {
      if (now) {
        this.student.school_type = now.value
      } else {
        this.student.school_type = ''
      }
    },

    'watch.priority': function (now, old) {
      if (now) {
        this.student.priority = now.value
      } else {
        this.student.priority = ''
      }
    }
  },

  methods: {
    select (selectedOption, id) {
      // console.log(selectedOption)
      // console.log(selectedOption.name)
      // console.log(selectedOption.value)
    },

    showModal () {
      this.condition.condition = !this.condition.condition
    },

    getData () {
      this.condition.condition = !this.condition.condition
      this.student.f_name = this.family.f_name
      this.student.f_name_kana = this.family.f_name_kana
    },

    postStudentModal () {
      this.$store.dispatch('postStudentModal', {
        family: this.family,
        student: this.student,
        condition: this.condition
      })
    }
  },
  mounted () {
  }
}
</script>

<style lang='scss' scoped>
.req {
  background: #dffbef;
}
.expand-transition {
  transition: all .3s ease;
  height: 30px;
  padding: 10px;
  background-color: #eee;
  overflow: hidden;
}
.expand-enter, .expand-leave {
  height: 0;
  padding: 0 10px;
  opacity: 0;
}
table {
  border-spacing: 0;
  width: 100%;
  tr {
    th {
      border-bottom: solid 1px #ddd;
      background: #f4f4f4;
      color: #333;
      padding: 10px;
    }
    td {
      border-bottom: solid 1px #ddd;
      input {
        outline: 0;
        border: none;
        width: 100%;
      }
      .half {
        width: 50%;
      }
      textarea {
        outline: 0;
        border: none;
        width: 100%;
        height: 100px;
      }
      .calc {
        padding: 10px;
      }
    }
  }
}
.footer {
  width: 100%;
  display: flex;
  .m-btn + .m-btn {
    margin-top: 0;
  }
}
</style>
<style lang="scss">
.FamilyStudentsModal {
  .multiselect {
    min-height: 26px;
  }
  .multiselect__tags {
    border: 0;
    min-height: 26px;
    padding: 0px 40px 0 2px;
    font-size: .85rem;
  }
  .multiselect__input {
    margin-bottom: 0;
    height: 26px;
    font-size: .85rem;
  }
  .multiselect__select {
    height: 26px;
  }
  .multiselect__single {
    margin-top: 3px;
    margin-bottom: 3px;
  }
  .multiselect__placeholder {
    padding: .5rem 3px;
    margin: 0;
    color: #ccc;
  }
}
</style>



// WEBPACK FOOTER //
// FamilyStudentsModal.vue?96a0d6e6